import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'VocabularyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vocabulary",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 5v16"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 7h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 11h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 7h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 11h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 15h1"
    }, null), _createTextVNode(" ")]);
  }
};